function getCssVariable(name: string, from: HTMLElement = document.body) {
  return getComputedStyle(from).getPropertyValue(name).trim();
}

export const BackgroundPlugin = {
  id: "backgroundPlugin",
  beforeDraw: (chart: any) => {
    const {
      ctx,
      chartArea: { left, top, width, height },
    } = chart;

    const borderRadius = 4;
    const r = Math.min(borderRadius, width / 2, height / 2);

    const fillColor = getCssVariable("--v2-overlay-shadow-200");
    const strokeColor = getCssVariable("--v2-border-tertiary");

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(left + r, top);
    ctx.lineTo(left + width - r, top);
    ctx.quadraticCurveTo(left + width, top, left + width, top + r);
    ctx.lineTo(left + width, top + height - r);
    ctx.quadraticCurveTo(
      left + width,
      top + height,
      left + width - r,
      top + height,
    );
    ctx.lineTo(left + r, top + height);
    ctx.quadraticCurveTo(left, top + height, left, top + height - r);
    ctx.lineTo(left, top + r);
    ctx.quadraticCurveTo(left, top, left + r, top);
    ctx.closePath();

    ctx.fillStyle = fillColor;
    ctx.fill();
    ctx.clip();

    ctx.shadowBlur = 25;
    ctx.shadowColor = "rgba(0, 0, 0, 0.4)";
    ctx.lineWidth = 1;
    ctx.strokeStyle = strokeColor;
    ctx.stroke();
    ctx.restore();

    ctx.save();
  },
};
